import React from 'react';

import Image from 'next/image';
import Link from 'next/link';

import { Logo } from '../../../components/Logo/Logo';
import { colors } from '../../../styles/constants';
import { TCopyrightsProps } from '../FooterV2.types';
import {
  FooterCopyrightWrapper,
  FooterCopyrightLocalization,
  FooterCopyrightSocial,
  FooterCopyrightLogo,
  FooterCopyrightLocalizationText,
} from './FooterCopyrightV2.style';

export const FooterCopyrightV2 = ({
  logo,
  localization,
  socials,
  openLanguageModal,
}: TCopyrightsProps) => {
  return (
    <FooterCopyrightWrapper>
      <FooterCopyrightLogo>
        {logo?.filename && <Logo logo={logo} />}
        {localization && (
          <FooterCopyrightLocalization onClick={openLanguageModal}>
            <Image width={16} alt="pin" height={16} src={'/assets/images/pin-black.svg'} />
            <FooterCopyrightLocalizationText color={colors.black}>
              {localization}
            </FooterCopyrightLocalizationText>
          </FooterCopyrightLocalization>
        )}
      </FooterCopyrightLogo>
      <FooterCopyrightSocial>
        {socials?.map((social) => (
          <Link key={social._uid} href={social.url}>
            <a>
              <Image width={22} height={24} src={social.icon.filename} alt={social.name} />
            </a>
          </Link>
        ))}
      </FooterCopyrightSocial>
    </FooterCopyrightWrapper>
  );
};
